<template>
   <div id="ms-documentation" class="content content--borderless">
    <div class="content__header">
      <div class="content__main-header">
        <div class="content__title">
          <div class="content__title__name">Daftar Pengguna <span class="text-primary">{{sdiOrganization && sdiOrganization.name}}</span></div>
          <div class="content__title__description">Daftar pengguna yang mempunyai akses di Indonesia Data Hub.</div>
        </div>
        <div class="ml-auto">
          <button 
            type="button" 
            class="button" variant="primary" size="sm" 
            :disabled="addUserDisabled" 
            @click="showModalAddNewUser" 
          >
            <VueFeather type="user-plus" size="16" stroke-width="2" style="display:block"></VueFeather>&nbsp;
            Tambah Pengguna
          </button>
        </div>
      </div>
      <div class="tags" style="margin:0;padding:0" v-if="sdiOrganization">
        <div class="tag tag--primary">
          <div class="tag__field">Role</div>
          <div class="tag__value">{{capitalize(sdiOrganization.role)}}</div>
        </div>
        <div class="tag tag--secondary "> 
          <div class="tag__field">Level</div>
          <div class="tag__value">{{capitalize(sdiOrganization.level)}}</div>
        </div>
      </div>
      
    </div>
    <div class="content__body mt-3">
      <div class="alert alert--warning" v-if="!isBps">
        <div class="alert__icon">
          <VueFeather type="alert-triangle" size="18"></VueFeather>
        </div>
        <div class="alert__value">
          <div class="alert__value__title">Pemberitahuan</div>
          Pada saat ini user yang diperbolehkan mengakses sistem adalah maksimal 2. Silahkan edit user yang ada untuk mengganti user atau hubungi Administrator INDAH untuk penambahan lebih dari 2 user. Terima Kasih.
        </div>
      </div>

      <div class="table-search mb-2 form form--sm">
        <b-input-group >
          <b-input-group-prepend is-text class="bg-none">
            <VueFeather type="search" size="16" stroke-width="3" stroke="#919191" ></VueFeather>
          </b-input-group-prepend>
          <b-form-input 
            type="search"
            debounce="500"
            v-model="filter.name" 
            placeholder="Cari user berdasarkan nama . . ." 
            class="border-left-0 min-w-400"></b-form-input>
        </b-input-group>
      </div>

      <div class="table-wrapper">
        
        <b-table
          class="table--light"
          show-empty
          :items="userTable.items"
          :fields="userTable.fields"
        >
          
          <template #cell(no)="data"> 
            {{  ((userTable.pagination.currentPage-1)*userTable.pagination.pageSize+1) + data.index }} </template>
          <template #cell(roles)="data">
            <div class="d-flex" v-for="(role,index) in data.value" :key="index">
              <div class="w-15" v-if="data.value.length>1">{{index+1}}.</div>
              <div>{{role ? roleFormatter(role.name)  : '-'}}</div>
            </div>
          </template>
          <template #cell(action)="data">
              <div class="d-flex justify-content-center">
               
                <b-link  
                  class="button button--action button--action--edit " 
                  v-b-popover.hover="{content: 'Kirim password ulang' , placement: userTable.items.length>1 ? 'top' : 'bottom'}"
                  @click="resendUserPassword(data.item.id)"
                  v-if="data.item.email && data.item.email.split('@')[1] != 'bps.go.id'"
                > 
                    <VueFeather type="send" size="14"></VueFeather>
                </b-link>

                <b-link  
                    class="button button--action button--action--delete " 
                    v-b-popover.hover="{content: 'Hapus role pembina data dari user' , placement: userTable.items.length>1 ? 'top' : 'bottom'}"
                    @click="deleteUser(data.item.id)"
                    v-if="isBps"
                > 
                    <VueFeather type="x" size="16"></VueFeather>
                </b-link>
                <b-link  
                    class="button button--action button--action--edit " 
                    v-b-popover.hover="{content: 'Edit' , placement: userTable.items.length>1 ? 'top' : 'bottom'}"
                    @click="showModalUpdateUser(data.item)"
                > 
                    <VueFeather type="edit-2" size="14"></VueFeather>
                </b-link>
                
              </div>
          </template>
          <template #empty>
              <div class="table__empty">
              <div v-if="userTable.isLoading">
                <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data</div>
              <div v-else>
                <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                    Belum ada data pengguna yang tersedia
              </div>
              </div>
          </template>
        </b-table>
      </div>
      <b-pagination
        class="mt-3 pb-5 "
        align="center"
        v-model="userTable.pagination.currentPage"
        :total-rows="userTable.pagination.totalElements"
        :per-page="userTable.pagination.pageSize"
        @input="doFilter"
      ></b-pagination>
    </div>
    <b-toast id="toast" variant="danger" solid body-class="text-manrope text-medium" no-close-button toaster="b-toaster-top-center">
      <template #toast-title>
        <div class="d-flex flex-grow-1 align-items-center text-manrope text-semi-bold">
          <b-img blank blank-color="#e32929" class="mr-2" width="10" height="10"></b-img>
          <strong class="mr-auto">{{toast.title}}!</strong>
          <small class="text-muted mr-2">{{toast.time}}</small>
        </div>
      </template>
      {{toast.message}}
    </b-toast>

    <b-modal hide-header hide-footer  id="modal-add-update-user" modal-class="modal-secondary primary">
      <div class="modal__header secondary">
         <div class="modal__header__icon"><VueFeather type="user-plus" size="18" stroke-width="2"></VueFeather></div>
         <div>
          <div class="modal__title">  {{ newUser ? 'Tambah' : 'Update'}} Pengguna </div>
          <div class="modal__description">Isikan secara lengkap form yang disediakan </div>
         </div>
         <div class="modal__header__close">
          <b-button  class="button button--action button--action--view" @click="$bvModal.hide('modal-add-update-user')">
              <VueFeather type="x" size="14" stroke-width="2"></VueFeather>
          </b-button>
         </div>
      </div>
      <div class="modal__body mb-2 form form--sm">
        <ValidationObserver ref="userObserver" v-slot="{validate}">

          <b-form-group label="Username akun SSO BPS" v-if="isBps">
            <Treeselect 
              clearable
              valueFormat="object"
              placeholder="Username"
              v-model="ssoUser"
              :async="true"
              :options="options.ssoUser"
              :loadOptions="ssoUserLoadOptions"
              :normalizer="ssoUserNormalizer"
              searchPromptText="Ketikkan beberapa huruf terlebih dahulu untuk memulai pencarian... "
              @input="()=>{
                if(ssoUser){
                  user.name = ssoUser.name;
                  user.email= ssoUser.email;
                  user.username = user.email.split('@')[0];
                  user.isSso = true;
                }else{
                  user.name = null;
                  user.email= null;
                  user.username = null;
                  user.isSso = false;
                } 
              }"
            />
        </b-form-group>

          <ValidationProvider name="Nama" rules="required" v-slot="{errors}">
              <b-form-group label="Nama">
                <b-form-input 
                  v-model="user.name" 
                  placeholder="Tuliskan nama lengkap pengguna"
                  :state="errors[0] ? false: (user.name ? true : null)"
                  :disabled="isBps"
                >
                </b-form-input>
                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
          </ValidationProvider>

          <ValidationProvider name="Email" rules="required|email" v-slot="{errors}">
              <b-form-group label="Email" description="Pastikan alamat email aktif, karena informasi alamat e-mail akan digunakan system untuk mengirimkan password pengguna">
                <b-form-input 
                    v-model="user.email" 
                    placeholder="Email aktif pengguna"
                    :state="errors[0] ? false: (user.email ? true : null)"
                    :disabled="isBps"
                    @input="isDuplicateError = false; user.username = user.email.split('@')[0];"
                >
                </b-form-input>
                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
          </ValidationProvider>

          <b-form-group label="Role">
            <Treeselect 
              v-model="user.roleIds"
              :clearable="false"
              :options=" options.roles"
              :multiple="isSuperAdmin"
              :normalizer="(node)=>({id:node.id, label:node.name})"
              :disabled="!isSuperAdmin"
            >
              <label slot="option-label" slot-scope="{node,labelClassName}" :class="labelClassName">
                {{getRoleNameById(node.id) }}
              </label>
              <div slot="value-label" slot-scope="{ node }">{{ getRoleNameById(node.id) }}</div>
            </Treeselect>
          </b-form-group>

          <b-form-group label="Organisasi" v-if="isSdiRoles(user.roleIds)">
            <Treeselect 
              clearable
              valueFormat="object"
              placeholder="Pilih organisasi user"
              v-model="user.sdiOrganization"
              :async="true"
              :options="null"
              :loadOptions="sdiOrganizationLoadOptions"
              :normalizer="sdiOrganizationNormalizer"
              :disabled="!isSuperAdmin"
              searchPromptText="Ketikkan beberapa huruf terlebih dahulu untuk memulai pencarian... "
            />
          </b-form-group>


          <div class="alert alert--danger" v-if="isDuplicateError">
            <div class="alert__icon">
              <VueFeather type="alert-triangle" size="18" stroke-width="2"></VueFeather>
            </div>
            <div class="alert__value">
              <div class="alert__value__title">Gagal menyimpan</div>
              {{errorMessage409}}
            </div>
          </div>
        
          <div class="d-flex align-items-center justify-content-end">
              <b-button  v-if="newUser" class="button button--primary" :disabled="userExist(user.email)" @click="()=>{
                validate().then(result=>{
                    if(result){
                      addUser();
                    }
                })   
              }">
                <span v-if="isSaving" class="d-flex align-items-center ">
                  <VueFeather type="loader" animation="spin" size="14"></VueFeather> &nbsp;&nbsp;Simpan . . .
                </span>
                <span v-else>Simpan</span>
              </b-button>
              <b-button v-if="!newUser" class="button button--primary" @click="()=>{
                validate().then(result =>{
                    if(result){
                      updateUser();
                    }
                })   
              }" >
                <span v-if="isSaving" class="d-flex align-items-center ">
                  <VueFeather type="loader" animation="spin" size="14"></VueFeather> &nbsp;&nbsp;Updating . . .
                </span>
                <span v-else>Update</span>
              </b-button>
          </div>
        </ValidationObserver>
      </div>
   </b-modal>
   <b-modal  
      id="access-server" size="sm"
      hide-header hide-footer  content-class="text-center py-3 px-3" centered dialog-class="d-flex justify-content-center"
    >
      <div v-if="modal.accessServer.isLoading">
        <div class="text-center py-3">
          <img src="@/assets/img/loader.gif" width="100" height="100" />
          <div style="font-weight:600;font-size:16px;color:#01ad85">
            Mohon tunggu sebentar 
          </div>
          <div style="font-weight:500;font-size:13px;color:#0a4e5c;">
            {{modal.accessServer.loadingMessage}}
          </div>
        </div>
      </div>
      <div v-else>
        <div class="text-center py-3" style="color:red">
          <div >
            <VueFeather type="x-circle" size="50" stroke-width="1"></VueFeather>
          </div>
          <div style="font-weight:600;font-size:17px;color:red">
            Error 
          </div>
          <div style="font-weight:600;font-size:13px;color:#0a4e5c;font-family:'Open Sans'">
            {{modal.accessServer.errorMessage}}
          </div>
          <div class="mt-2">
            <b-button 
              style="background-color:#2e2e2e !important;padding:3px 10px;border-radius:3px !important; font-weight:600" 
              v-on:click="()=>{$bvModal.hide('access-server');}">Kembali</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
  
</template> 
<script>
import wilayahService from "@/services/WilayahService";
import SdiOrganizationService from "@/services/SdiOrganizationService";
import UserService from "@/services/UserService";
import moment from 'moment'
import VueFeather from 'vue-feather';
import { ValidationObserver,ValidationProvider } from "vee-validate";
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import store from "@/store";
import * as role from "@/views/ms/SdiRole.js"
export default {
  components:{
    VueFeather,
    ValidationObserver,
    ValidationProvider,
    Treeselect
  },
  data(){
    return{
      sdiOrganization: null,
      toast:{
        title:null,
        message:null,
        time:null
      },
      provinceFilterDisabled:false,
      cityFilterDisabled:false,
      filter:{
         name:null,
         provinceCode:null,
         cityCode: null,
         sdiRole:null,
         sdiOrganizationId:null,
      },
      userTable:{
        isLoading: true,
        items:[],
        pagination:{
          currentPage:1,
          pageSize: 10,
          totalPages: null,
          totalElements:0,
          goto:null
        },
        fields:[
          {
              key:'no',
              class:'text-center w-51'
          },
          {
              key:'name',
              label: 'Nama',
              class:'text-left'
          },
          {
              key:'email',
              class:'text-left'
          },
          {
              key: 'username',
              label: 'username',
              class:'text-left'
          },
          {
              key:'roles',
              label:'Role',
              class:'text-left '
          },
          {
              key:'action',
              label: 'Aksi',
              class:'text-center text-nowrap w-101'
          },
        ],
      },
      user:{
        name:null,
        username:null,
        email:null,
        sdiOrganization:null,
        roleIds:[],
        isSso:false,
      },
      userRoles:null,
      userOrganization:null,
      ssoUser:null,
      newUser:true,
      updatedUserId:null,
      isDuplicateError:false,
      errorMessage409: null,
      isSaving:null,

      modal:{
        accessServer:{
          isLoading:false,
          loadingMessage:null,
          isError:false,
          errorTitle:null,
          errorMessage:null,
          
        },
      },

      
      
      options:{
        roles:[],
        ssoUser: null,
        sdiRole:[
          {id:'PEMBINA_DATA', label : 'Pembina Data'},
          {id:'WALIDATA', label : 'Walidata'},
          {id:'PRODUSEN_DATA', label : 'Produsen Data'}
        ],
        province:[
          {
            id: 0,
            code: '00',
            name: "PUSAT",
          },
          {
            id: 1,
            code: '11',
            name: "ACEH"
          },
          {
            id: 2,
            code: '12',
            name: "SUMATERA UTARA"
          },
          {
            id: 3,
            code: '13',
            name: "SUMATERA BARAT"
          },
          {
            id: 4,
            code: '14',
            name: "RIAU"
          },
          {
            id: 5,
            code: '15',
            name: "JAMBI"
          },
          {
            id: 6,
            code: '16',
            name: "SUMATERA SELATAN"
          },
          {
            id: 7,
            code: '17',
            name: "BENGKULU"
          },
          {
            id: 8,
            code: '18',
            name: "LAMPUNG"
          },
          {
            id: 9,
            code: '19',
            name: "KEPULAUAN BANGKA BELITUNG"
          },
          {
            id: 10,
            code: '21',
            name: "KEPULAUAN RIAU"
          },
          {
            id: 11,
            code: '31',
            name: "DKI JAKARTA"
          },
          {
            id: 12,
            code: '32',
            name: "JAWA BARAT"
          },
          {
            id: 13,
            code: '33',
            name: "JAWA TENGAH"
          },
          {
            id: 14,
            code: '34',
            name: "DI YOGYAKARTA"
          },
          {
            id: 15,
            code: '35',
            name: "JAWA TIMUR"
          },
          {
            id: 16,
            code: '36',
            name: "BANTEN"
          },
          {
            id: 17,
            code: '51',
            name: "BALI"
          },
          {
            id: 18,
            code: '52',
            name: "NUSA TENGGARA BARAT"
          },
          {
            id: 19,
            code: '53',
            name: "NUSA TENGGARA TIMUR"
          },
          {
            id: 20,
            code: '61',
            name: "KALIMANTAN BARAT"
          },
          {
            id: 21,
            code: '62',
            name: "KALIMANTAN TENGAH"
          },
          {
            id: 22,
            code: '63',
            name: "KALIMANTAN SELATAN"
          },
          {
            id: 23,
            code: '64',
            name: "KALIMANTAN TIMUR"
          },
          {
            id: 24,
            code: '65',
            name: "KALIMANTAN UTARA"
          },
          {
            id: 25,
            code: '71',
            name: "SULAWESI UTARA"
          },
          {
            id: 26,
            code: '72',
            name: "SULAWESI TENGAH"
          },
          {
            id: 27,
            code: '73',
            name: "SULAWESI SELATAN"
          },
          {
            id: 28,
            code: '74',
            name: "SULAWESI TENGGARA"
          },
          {
            id: 29,
            code: '75',
            name: "GORONTALO"
          },
          {
            id: 30,
            code: '76',
            name: "SULAWESI BARAT"
          },
          {
            id: 31,
            code: '81',
            name: "MALUKU"
          },
          {
            id: 32,
            code: '82',
            name: "MALUKU UTARA"
          },
          {
            id: 33,
            code: '91',
            name: "PAPUA BARAT"
          },
          {
            id: 34,
            code: '94',
            name: "PAPUA"
          }
        ],
        city:[
          {
            id: 0,
            code: '0000',
            name: "PUSAT",
            provinsiId:null
          }
        ]
      }
    }
  },
  watch:{
    'filter.provinceCode'(){
        this.provinceChanged(this.filter.provinceCode); 
    },
    'filter.name'(){
        this.doFilter()
    }
  },
  computed:{
    isBps(){
      return this.sdiOrganization &&  this.sdiOrganization.email && this.sdiOrganization.email.split('@')[1]=='bps.go.id' ;
    },
    addUserVisible(){
      if(this.sdiOrganization){
        return this.userOrganization.id != this.sdiOrganization.id ? true : false;
      }else{
        return false
      }
    },
    addUserDisabled(){
      if(this.isBps){
        return false
      }else{
        if(this.userTable.items.length>=2 ){
          return true;
        }else{
          return false
        }
      }
    },
    isSuperAdmin(){
      return store.getters["auth/user"].role.slice(1,-1).split(", ").includes("ROLE_SUPERADMIN");
    },
    role(){
      return role;
    },
    isPembinaDataProvinsi(){
      return role.isPembinaDataProvinsi(this.userRoles);
    },
    isPembinaData(){
      return role.isPembinaData(this.userRoles);
    }
    
  },
  async mounted(){
    this.userOrganization = store.getters["auth/user"].sdiOrganization;
    this.userRoles = store.getters["auth/user"].role.slice(1,-1).split(", ");
    
    //superadmin            -> pembina data provinsi (user bps via sso) / all user
    //pembina data pusat    -> pembina data provinsi (user bps via sso) & assign user walidata pusat (max 2)
    //pembina data provinsi -> pembina data kabkota  (user bps via sso) & assign user walidata provinsi (max 2)
    //pembina data kabkota  -> assign user walidata kabkota (max 2)
    this.getAllUser();
    this.getAllRoles();
    this.getSdiOrganizationDetail(this.$route.params.id);
    // if(role.isSuperAdmin){
      
      
    // }else{
    //   await this.getSdiOrganizationDetail(id);
    //   await this.getSdiRoles();
    //   this.setUserRoles();
    // }
    
  },
  methods:{
    doFilter(){
      this.scrollTop()
      this.getAllUser();
    },
    async resendUserPassword(id){
      this.modal.accessServer.isLoading = true;
      this.modal.accessServer.loadingMessage = 'Proses mengirimkan password terbaru sedang dikirimkan';
      this.$bvModal.show('access-server');
      await UserService.resendUserPassword(id).then(
        () =>{
           this.$bvModal.hide('access-server');
        },
      ).catch(error=>{
        this.modal.accessServer.isLoading = false;
        this.modal.accessServer.errorMessage = error.response;
      });
    },
    async getAllUser(){
      this.userTable.items = [];
      this.userTable.isLoading = true;
      let sdiOrganizationId = this.$route.params.id;
      let name = this.filter.name;
      let page = this.filter.name ? 0 : this.userTable.pagination.currentPage -1;
      await UserService.getAllUserBySdiOrganizationId(page, name, sdiOrganizationId).then(
        (result) =>{
          this.userTable.items = result.data.content;
          this.userTable.pagination.pageSize = result.data.size;
          this.userTable.pagination.totalElements = result.data.totalElements;
        },
      )
      .catch(error=>{
        console.log(error.response)
        this.toast.title = 'Gagal mengambil data user';
        this.toast.message = error.response;
        this.toast.time = moment().startOf('second').fromNow(); 
        this.$bvToast.show('toast');
      });
      
      this.userTable.isLoading = false;
    },
    async deleteUser(id){
      this.$bvModal.show('access-server');
      this.modal.accessServer.message = "Proses menghapus role Pembina Data dari User sedang berlangsung";
      await UserService.deleteSdiRoleUser(id).then(
        () =>{
          this.$bvModal.hide('access-server');
          this.getAllUser();
        },
      ).catch(error=>{
        this.toast.title = 'Gagal menghapus user';
        this.toast.message = JSON.parse(JSON.stringify(error)).message;
        this.toast.time = moment().startOf('second').fromNow(); 
        this.$bvToast.show('toast');
      });
      this.$bvModal.hide('access-server');
    },
    async addUser(){
      this.isSaving = true;
      this.isDuplicateError = false;
      let sdiOrganization = {...this.user.sdiOrganization};
      delete this.user.sdiOrganization;
      this.user.sdiOrganizationId = sdiOrganization ? sdiOrganization.id : null;
      await UserService.addSdiUser(this.user).then(
        () =>{
          this.$bvModal.hide('modal-add-update-user');
          this.getAllUser();
        },
      ).catch(error=>{
        this.user.sdiOrganization = sdiOrganization;
        if(error.response.data.status == 409){
          this.isDuplicateError = true;
          this.errorMessage409 = error.response.data.message;
        }else{
          this.toast.title = 'Gagal menambah user';
          this.toast.message = JSON.parse(JSON.stringify(error)).message;
          this.toast.time = moment().startOf('second').fromNow(); 
          this.$bvToast.show('toast');
        }
      });
      this.isSaving = false;
    },
    async updateUser(){
      this.isSaving = true;
      let sdiOrganization = {...this.user.sdiOrganization};
      delete this.user.sdiOrganization;
      this.user.sdiOrganizationId = sdiOrganization ? sdiOrganization.id : null;
      await UserService.updateSdiUser(this.updatedUserId,this.user).then(
        () =>{
          
          this.$bvModal.hide('modal-add-update-user');
          this.getAllUser();
        },
      ).catch(error=>{
        this.user.sdiOrganization = sdiOrganization;
        if(error.response.data.status == 409){
          this.isDuplicateError = true;
          this.errorMessage409 = error.response.data.message;
        }else{
          this.toast.title = 'Gagal mengupdate user';
          this.toast.message = JSON.parse(JSON.stringify(error)).message;
          this.toast.time = moment().startOf('second').fromNow(); 
          this.$bvToast.show('toast');
        }
      });
      this.isSaving = false;
    },
    showModalAddNewUser(){
      this.isDuplicateError = false;
      this.newUser = true;
      this.$bvModal.show('modal-add-update-user');
      this.ssoUser=null;
      this.user ={
        name:null,
        username:null,
        email:null,
        sdiOrganization:this.sdiOrganization,
        roleIds:[],
        isSso:false,
      }
      let roleName = 'ROLE_'+this.sdiOrganization.role;
      roleName = this.sdiOrganization.level == 'KABUPATEN_KOTA' ? roleName + '_KABKOTA' : roleName +'_'+this.sdiOrganization.level;
      let roleId = this.options.roles.find(x => x.name == roleName).id;
      this.user.roleIds = roleId ? [roleId] : []
    },
    showModalUpdateUser(user){
      this.isDuplicateError = false;
      this.updatedUserId = user.id;
      this.newUser = false;
      let isSso = user && user.email && user.email.split('@')[1] == 'bps.go.id';
      this.$bvModal.show('modal-add-update-user');
      this.user ={
        name:user.name,
        username:user.username,
        email:user.email,
        sdiOrganization:user.sdiOrganization,
        roleIds:[],
        isSso: isSso,
      }
      let roleName = 'ROLE_'+this.sdiOrganization.role;
      roleName = this.sdiOrganization.level == 'KABUPATEN_KOTA' ? roleName + '_KABKOTA' : roleName +'_'+this.sdiOrganization.level;
      let roleId = this.options.roles.find(x => x.name == roleName).id;
      this.user.roleIds = roleId ? [roleId] : []
    },
    async getSdiOrganizationDetail(id){
      await SdiOrganizationService.getSdiOrganizationById(id).then(
        (result) =>{
          this.sdiOrganization = {...result.data};
        },
      ).catch(error=>{
        console.log(JSON.parse(JSON.stringify(error)));
        this.toast.title = 'Gagal Menarik Data User';
        this.toast.message = JSON.parse(JSON.stringify(error)).message;
        this.toast.time = moment().startOf('second').fromNow(); 
        this.$bvToast.show('toast');
      });
    },
    async getAllRoles(){
      await UserService.getAllRoles().then(
        (result) =>{
          this.options.roles = result.data.map(x=>({id:x.id,name:x.role, project:x.project}));
        },
      ).catch(error=>{
        this.toast.title = 'Gagal menarik data roles';
        this.toast.message = JSON.parse(JSON.stringify(error)).message;
        this.toast.time = moment().startOf('second').fromNow(); 
        this.$bvToast.show('toast');
      });
    },
    setUserRoles(){
      let role = this.sdiOrganization.role;
      let level = this.sdiOrganization.level;
      if(role == 'PEMBINA_DATA'){
        this.user.roleIds = 
          level == 'PUSAT' ? [this.roleId('ROLE_PEMBINA_DATA_PUSAT')] : (
          level == 'PROVINSI' ? [this.roleId('ROLE_PEMBINA_DATA_PROVINSI')] : [this.roleId('ROLE_PEMBINA_DATA_KABKOT')] )
      }else if(role == 'WALIDATA'){
        this.user.roleIds = 
          level == 'PUSAT' ? [this.roleId('ROLE_WALIDATA_PUSAT')] : (
          level == 'PROVINSI' ? [this.roleId('ROLE_WALIDATA_PROVINSI')] : [this.roleId('ROLE_WALIDATA_KABKOT')] )
      }else{
        this.user.roleIds = 
          level == 'PUSAT' ? [this.roleId('ROLE_PRODUSEN_DATA_PUSAT')] : (
          level == 'PROVINSI' ? [this.roleId('ROLE_PRODUSEN_DATA_PROVINSI')] : [this.roleId('ROLE_PRODUSEN_DATA_KABKOT')] )
      }
    },
    isSdiRoles(roleIds){
      let sdiRoleIds = this.options.roles.filter(x=>x.project == 'SDI').map(x=>x.id);
      return roleIds.some( role => sdiRoleIds.includes(role))
    },
    getRoleNameById(id){
      if(id && !this.options.roles || this.options.roles.length == 0){
        return '-'
      }
      let role = this.options.roles.find(x=> x.id == id);
      return role ? this.roleFormatter(role.name) : null
    },
    roleFormatter(roleName){
      if(!roleName){
        return '-'
      }
      roleName = roleName.replace('ROLE_','')
      roleName = roleName.replace('_',' ')
      roleName = roleName.replace('KABKOTA','Kabupaten/Kota')
      return this.capitalize(roleName);
    },
    roleId(roleName){
      let role = this.options.roles.length>0 ? this.options.roles.find(x=>x.name == roleName) : null;
      return role ? role.id :null
    },
    capitalize(sentence){
      return sentence ? sentence.replaceAll('_',' ').toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()) : '-';
    },
    async ssoUserLoadOptions({searchQuery, callback}){
      await UserService.getSsoUserByUsername(searchQuery).then(
        (result) => {
          let options = result.data.result.map((element) => {
            return {
              name: element.firstName + " " + element.lastName,
              username: element.username,
              email: element.email,
            };
          });
          callback(null, options)
        },

        (error) => {
          console.log(error);
        }
      );
    },
    ssoUserNormalizer(node) {
      return {
        id: node.username,
        label: node.name,
      }
    },
    userExist(email){
      if(!email){
        return false;
      }
      let users = this.userTable.items.map(x=>x.email);
      return users.includes(email);
      
    },

    sdiOrganizationNormalizer(node) {
      return {
         id: node.id,
         label: node.name,
      }
    },
    loadOptions({callback}) {
      let result = 'Sedang melakukan load data'
      callback(null, result)
    },
    async sdiOrganizationLoadOptions({searchQuery, callback}){
        let name = searchQuery;
        let page = 0;
        let provinceCode = null;
        let cityCode = null;
        await SdiOrganizationService.getAllSdiOrganization(page, name, provinceCode, cityCode).then(
          (result)=>{
              let options = result.data.content;
              // console.log(options)
              callback(null, options)
          },
          (error)=>{
              console.log(error)
          }
        )
    },
    walidataChanged(){
        this.organization.walidata = {id:this.walidata.id, name:this.walidata.name};
    },
    normalizer(node) {
        return {
          id: node.value,
          label: node.label,
          children: node.children,
        }
    },
    provinceNormalizer(node){
        return {
          id: node.code,
          label: node.name,
        }
    },
    cityNormalizer(node){
        return {
          id: node.code,
          label: node.name,
        }
    },
    provinceChanged(provCode){
      if(!this.provinceFilterDisabled || !this.cityFilterDisabled){
         this.filter.cityCode=null;
         if(provCode == '00'){
            this.options.city = [{
               id: 0,
               code: '0000',
               name: "PUSAT",
               provinsiId:null
            }];
         }else{
            if(provCode){
               let prov = this.options.province.find(x=>x.code == provCode);
               this.getKabupatenKotaList(prov.id, provCode);
            }
         }
      }
      if(this.provinceFilterDisabled && this.cityFilterDisabled){
         if(provCode){
            let prov = this.options.province.find(x=>x.code == provCode);
            this.getKabupatenKotaList(prov.id, provCode);
         }
      }
   },
   async getKabupatenKotaList(provinceId, provinceCode){
      wilayahService.getKabupatenKotaByIdProvinsi(provinceId).then(
         (result) => {
               let options = result.data.data;
               this.options.city = options.map(x=>({id:x.id, code:x.kode,name:x.nama}));
               this.options.city = [
                  {
                     id: 9999,
                     code: provinceCode+'00',
                     name: "PROVINSI",
                  }, ...this.options.city]
         },
         (error) => {
               this.error=error;
         }
      );
   },
    scrollTop() {
      // setTimeout(function() {}, 100);
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    },
    
  }
}
</script>